import * as React from 'react';
import * as _ from 'underscore';
//import * as $ from 'jquery';

import { ParameterField } from '../ParameterField';
import { IGlob } from '../../../../pdc-platform/src/ts/Glob';

export interface IFormEditMixinComponentOptions {
    onChange?(...params): void;
}

export interface IFormEditMixinComponentProperties<TOptions extends IFormEditMixinComponentOptions> {
    options?: TOptions;

    onChange?(...params): void;

    glob: IGlob;
}

export interface IFormEditMixinComponent<
    TProps extends IFormEditMixinComponentProperties<TOptions>,
    TOptions extends IFormEditMixinComponentOptions
> extends React.Component<TProps, any> {
    returnInvalid?: boolean;
    fields?: string[];
}

export default class FormEditMixin<
    TProps extends IFormEditMixinComponentProperties<TOptions>,
    TOptions extends IFormEditMixinComponentOptions
> {
    private component: IFormEditMixinComponent<TProps, TOptions> = null;

    constructor(component: IFormEditMixinComponent<TProps, TOptions>) {
        this.component = component;
    }

    public handleChange = (param, name: string, value) => {
        param.validate(value);

        let obj = _.clone(this.component.state.value);

        obj[name] = value;

        this.component.setState({
            value: obj
        });

        if (param.errors.length !== 0 && this.component.returnInvalid !== true) {
            return;
        }

        if (param.options != null && typeof param.options.onChange === 'function') {
            param.options.onChange(obj);
        }

        if (typeof this.component.props.onChange === 'function') {
            this.component.props.onChange(obj);
        }

        if (this.component.props.options != null && typeof this.component.props.options.onChange === 'function') {
            this.component.props.options.onChange(obj);
        }
    };

    public validateAll = (params) => {
        if (this.component == null || this.component.fields == null) {
            return;
        }

        if (params == null) {
            params = this.component.state;
        }

        _.each(this.component.fields, (key: string) => {
            const param = params[key];
            if (param == null) {
                return;
            }

            param.validate(this.component.state.value[key]);
        });
    };

    public getField = (param, name: string) => {
        const EditComponent = param.constructor.EditComponent;
        const value = this.component.state.value[name];

        return (
            <ParameterField param={param} options={param.getOptions() || {}} glob={this.component.props.glob}>
                <EditComponent
                    value={value}
                    param={param}
                    options={param.getOptions() || {}}
                    onChange={(value) => {
                        this.handleChange(param, name, value);
                    }}
                    glob={this.component.props.glob}
                    {...param.getDirectOptions(value)}
                />
            </ParameterField>
        );
    };
}
